import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultInvoicePrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/Invoices/Print/templates/*/index.tsx"
);

type InvoicePrintProps = {
};

export default function InvoicePrint(props: InvoicePrintProps) {
  return (
    <TenantTemplateRouterCore<InvoicePrintProps>
      templates={templates}
      DefaultComponent={DefaultInvoicePrint}
      passProps={props}
    />
  );
}